import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteEmployeeDetailsReport } from './Pages/listing';

export const RouteEmployeeDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={RouteEmployeeDetailsReport} />
    </Fragment>
)